import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Combina clases de Tailwind CSS de manera inteligente
 * Evita conflictos y duplicados
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formatea un número como moneda en soles peruanos
 */
export function formatearMoneda(monto: number): string {
  return new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
  }).format(monto)
}

/**
 * Formatea una fecha en formato legible en español
 */
export function formatearFecha(fecha: Date | string): string {
  const fechaObj = typeof fecha === 'string' ? new Date(fecha) : fecha
  return new Intl.DateTimeFormat('es-PE', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(fechaObj)
}

/**
 * Formatea una fecha en formato corto
 */
export function formatearFechaCorta(fecha: Date | string): string {
  const fechaObj = typeof fecha === 'string' ? new Date(fecha) : fecha
  return new Intl.DateTimeFormat('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(fechaObj)
}

/**
 * Calcula los días restantes hasta una fecha
 */
export function diasRestantes(fecha: Date | string): number {
  const fechaObj = typeof fecha === 'string' ? new Date(fecha) : fecha
  const hoy = new Date()
  const diferencia = fechaObj.getTime() - hoy.getTime()
  return Math.ceil(diferencia / (1000 * 60 * 60 * 24))
}

/**
 * Verifica si una fecha ya venció
 */
export function estaVencido(fecha: Date | string): boolean {
  const fechaObj = typeof fecha === 'string' ? new Date(fecha) : fecha
  return fechaObj < new Date()
}
